import { Injectable } from '@angular/core';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { BehaviorSubject, Observable, of } from 'rxjs';

/**
 * Holds the header bell's notifications, in memory. There is no notifications API yet, so the
 * panel is empty; the bell stays as the place a real feed will plug into.
 */
@Injectable({ providedIn: 'root' })
export class NotificationsService {
    private _notifications = new BehaviorSubject<Notification[]>([]);

    get notifications$(): Observable<Notification[]> {
        return this._notifications.asObservable();
    }

    update(id: string, notification: Notification): Observable<Notification> {
        this._notifications.next(
            this._notifications.value.map((item) =>
                item.id === id ? notification : item
            )
        );

        return of(notification);
    }

    delete(id: string): Observable<boolean> {
        this._notifications.next(
            this._notifications.value.filter((item) => item.id !== id)
        );

        return of(true);
    }

    markAllAsRead(): Observable<boolean> {
        this._notifications.next(
            this._notifications.value.map((item) => ({ ...item, read: true }))
        );

        return of(true);
    }
}
